module.exports = __webpack_public_path__ + "media/images/grouplink-885558c99db9d9e38b9078274a96ee15.png";